import {districtList} from "@/composables/list/district.list";

/**
 * Тип для ключей округов
 */
export type DistrictKey = keyof typeof districtList;

/**
 * Получает название округа по его ключу
 * @param key - Ключ округа
 * @param format - Формат названия: 'short' (сокращенное) или 'full' (полное)
 * @returns Название округа или 'Все' если ключ не передан
 */
export function getDistrictName(key: DistrictKey | null | undefined, format: "short" | "full" = "short"): string {
  return key ? districtList[key][format] : "Все";
}